/**
 * Kroky wizardu podle typu podnikání.
 *
 * Wizard měl osm kroků napevno, takže se strojírny ptal na návratnost
 * reklamy a poměr placené návštěvnosti. Na to nemá čím odpovědět a nutit
 * ji k tomu znamená sbírat vymyšlená čísla.
 *
 * Zrcadlí bloky z core/typ_podnikani.py. Klíče musí souhlasit.
 */

/** Bloky otázek podle typu, shodné s backendem. */
const BLOKY = {
  eshop:   ['zakaznici', 'reklama', 'navstevnost', 'sklad'],
  obchod:  ['zakaznici', 'sklad'],
  vyroba:  ['sklad', 'zakazky', 'kapacita'],
  sluzby:  ['zakazky', 'kapacita'],
  ostatni: [],
};

/**
 * Kroky v pevném pořadí. `blok` je null u kroků, které platí vždy;
 * krok s blokem se zařadí jen tehdy, když ho typ podnikání má.
 */
const VSECHNY_KROKY = [
  { klic: 'zadani',     label: 'Zadání',     blok: null },
  { klic: 'spolecnost', label: 'Společnost', blok: null },
  { klic: 'finance',    label: 'Finance',    blok: null },
  { klic: 'zisk',       label: 'Zisk',       blok: null },
  { klic: 'kpi',        label: 'Zákazníci',  blok: 'zakaznici' },
  { klic: 'traffic',    label: 'Návštěvnost', blok: 'navstevnost' },
  { klic: 'kvalita',    label: 'Kvalita',    blok: null },
  { klic: 'vypocet',    label: 'Výpočet',    blok: null },
  { klic: 'vysledky',   label: 'Výsledky',   blok: null },
];

/** Vrátí kroky pro daný typ. Neznámý typ dostane plný e-shopový průchod. */
export function krokyProTyp(typ) {
  // Dokud typ není vybraný, ukazuje se plný průchod, aby lišta neposkakovala.
  const bloky = BLOKY[typ] || BLOKY.eshop;
  return VSECHNY_KROKY.filter(k => k.blok === null || bloky.includes(k.blok));
}

export function popiskyProTyp(typ) {
  return krokyProTyp(typ).map(k => k.label);
}

/** Klíč kroku na daném pořadí (číslováno od 1). */
export function klicKroku(typ, poradi) {
  const kroky = krokyProTyp(typ);
  return kroky[poradi - 1] ? kroky[poradi - 1].klic : null;
}

export function pocetKroku(typ) {
  return krokyProTyp(typ).length;
}
